module.exports = __webpack_public_path__ + "9042cfd8024017c9c7bb13a47e106a95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/columbia.png
// module id = 1634
// module chunks = 0